import { Controller } from "@hotwired/stimulus";

// LRPO-5507 (item 9) — `company_exact` pins the Company filter to an EXACT match.
// It is set ONLY by the Reports Hub company drilldowns, so a drilled list keeps
// reconciling with the count on the card it came from ("Acme" must not pull in
// "Acme Corp").
//
// It is a property of THAT DRILL, not of the panel. The drawer's serializeDraft()
// only walks named inputs inside the drawer, so without the hidden flag below,
// hitting Apply on a drilled URL would DROP the pin and silently widen the list the
// user is looking at. But blindly preserving it is worse: the moment the user edits
// the Company box they are running a typed search — a CONTAINS match — and a
// surviving pin would make their search for "Glob" an exact match that finds
// nothing. That is QA item 9, reintroduced one interaction later.
//
// So: keep the pin while the box is untouched, drop it the instant it is edited.
export default class extends Controller {
  static targets = ["flag"];

  clear() {
    if (this.hasFlagTarget) this.flagTarget.value = "";
  }
}
